module.exports = __webpack_public_path__ + "static/media/LiquidCheese.03b7891e.svg";